import { render, staticRenderFns } from "./ManageBaseTableFooterAddBtn.vue?vue&type=template&id=3c5b0c8e&scoped=true&"
import script from "./ManageBaseTableFooterAddBtn.vue?vue&type=script&lang=js&"
export * from "./ManageBaseTableFooterAddBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b0c8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
